document.addEventListener('DOMContentLoaded', function () {
    const animationElements = document.querySelectorAll('.scroll-animated');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('scroll-animation-triggered');
                }
                // else { entry.target.classList.remove('scroll-animation-triggered'); }
            });
        },
        {
            threshold: 0.2,
        }
    );

    animationElements.forEach((el) => observer.observe(el));
});

document.addEventListener('DOMContentLoaded', function () {
    const hint = document.querySelector('.scroll-hint');
    if (!hint) return;

    window.addEventListener('scroll', function () {
        if (window.scrollY > 0) {
            hint.classList.add('is-hidden');
        } else {
            hint.classList.remove('is-hidden');
        }
    });
});
